import React from 'react';
import { createRoot } from 'react-dom/client';
import { Form } from '../../../component/offer/report/Form';
import Client from '../../../model/api/Client';

const element = document.getElementById('report-offer-form');

if (element) {
	const root = createRoot(element);
	const client = new Client();
	root.render(
		<Form
			modal={window.Modal}
			apiClient={client}
			termsUrl={element.dataset.termsUrl}
			gdprUrl={element.dataset.gdprUrl}
			defaultEmail={element.dataset.email}
		/>
	);
}
